var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimit = function SvgLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Limit_svg__a)",
    fill: "#AFAFAF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.073 0H1.78C.802 0 0 .827 0 1.835V18.48c0 1.009.802 1.835 1.78 1.835h12.65a9.43 9.43 0 0 1-.857-2.101H2.038V2.102h23.777V7.51a8.86 8.86 0 0 1 2.038 1.359V1.835C27.853.827 27.052 0 26.073 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.965 6.445H1.63v-2.83h24.294v2.83h.041ZM3.546 14.613h7.568v1.947H3.546v-1.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.35 13.884s.408-.168.694-.308c.978-.49 2.377-1.317 2.377-1.317a.544.544 0 0 1 .666.098.584.584 0 0 1 .082.687s-.802 1.4-1.277 2.41c-.15.308-.286.686-.3.742-.013 1.233-.991 2.242-2.2 2.242-1.21 0-2.202-1.023-2.202-2.27s.965-2.242 2.16-2.27v-.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.391 8.308c-4.198 0-7.608 3.517-7.608 7.846 0 4.33 3.41 7.846 7.608 7.846 4.199 0 7.61-3.517 7.61-7.846 0-4.33-3.411-7.846-7.61-7.846Zm4.851 12.035a6.648 6.648 0 0 0 1.48-4.203c0-3.6-2.839-6.529-6.33-6.529-3.492 0-6.332 2.928-6.332 6.53 0 1.596.557 3.053 1.48 4.202l1.156-1.19a.53.53 0 0 1 .774 0 4.056 4.056 0 0 0 2.921 1.246 4.056 4.056 0 0 0 2.922-1.247.53.53 0 0 1 .774 0l1.155 1.191Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Limit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })))));
};
export default SvgLimit;